import { gql } from '@apollo/client';

export const GET_CREDENTIALS_CLIQUE_RETIRE = gql`
  query GetCliqueRetireCredentials($storeId: ID!) {
    getCliqueRetireCredentials(storeId: $storeId) {
      __typename
      ... on GetCliqueRetireCredentialsSuccess {
        code
        credentials {
          apiKey
          apiId
        }
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
